import "react-phone-number-input/style.css";
import CustomBreadcrumb from "../../components/CustomBreadcrumb";
import PageTitle from "../../components/PageTitle";
import CardWrapper from "../../layouts/CardWrapper";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useState, useEffect } from "react";
import { authAtom } from "../../states/auth";
import { useAtom } from "jotai";

// Admin Profile Tabs
import CompanyDetails from "./AdminProfile/CompanyDetails";
import ChangePassword from "./AdminProfile/ChangePassword";
import BusinessHours from "./AdminProfile/BusinessHours";
import Subscription from "./AdminProfile/Subscription";
import StorageLocation from "./AdminProfile/StorageLocation";
import PersonalDetails from "./ExpertProfile/PersonalDetails";
import ProfileOverviewExpertise from "./ExpertProfile/ProfileOverviewExpertise";


const RenderAdminProfile = ({ activeTab, userDetail, setAuth }) => {
  console.log("userDetail",userDetail)
  switch (activeTab) {
    case 0: return <CompanyDetails auth={userDetail} setAuth={setAuth} />;
    case 5: return <PersonalDetails auth={userDetail} setAuth={setAuth} />;
    case 6: return <ProfileOverviewExpertise auth={userDetail} setAuth={setAuth} />;
    case 1: return <BusinessHours auth={userDetail} />;
    case 2: return <ChangePassword auth={userDetail} />;
    case 3: return <Subscription />;
    case 4: return <StorageLocation />;
    default: return null;
  }
};

const ProfileOverview = () => {
  const BeadcrumbItems = [{ label: "Profile Overview", active: true }];
  const [auth, setAuth] = useAtom(authAtom);
  const [activeTab, setActiveTab] = useState(null);
  const [userDetail, setUserDetail] = useState({...auth});

  useEffect(()=>{
    if(auth?.user?.roleId === 2){
      setActiveTab(0);
    }else{
      setActiveTab(5);
    }
  },[auth])

  return (
    <>
      <div className="mb-4">
        <CustomBreadcrumb items={BeadcrumbItems} />
        <PageTitle title="Profile Overview" />
      </div>

      {/* {auth?.user?.roleId === 2 ? (<div>
        <Row>
          <Col className="col-md-3">
            <CardWrapper className="p-0">
              <div className="full-box-0">
                <ul className="profile-list">
                  <li className={activeTab === 0 ? 'profile-list-item active' : 'profile-list-item'} onClick={() => setActiveTab(0)}>Company Details</li>
                  <li className={activeTab === 1 ? 'profile-list-item active' : 'profile-list-item'} onClick={() => setActiveTab(1)}>Business Hours</li>
                  <li className={activeTab === 2 ? 'profile-list-item active' : 'profile-list-item'} onClick={() => setActiveTab(2)}>Change Password</li>
                  <li className={activeTab === 3 ? 'profile-list-item active' : 'profile-list-item'} onClick={() => setActiveTab(3)}>Subscription</li>
                  <li className={activeTab === 4 ? 'profile-list-item active' : 'profile-list-item'} onClick={() => setActiveTab(4)}>Storage & Location</li>
                </ul>
              </div>
            </CardWrapper>
          </Col>
          <Col className="col-md-9">
          <CardWrapper className="full-box-0 p-0">
            <RenderAdminProfile 
              activeTab={activeTab} 
              userDetail={auth} 
              setAuth={setAuth} 
            />
          </CardWrapper>
          </Col>
        </Row>
      </div>) : (<ExpertProfile auth={auth} />)} */}

      <div>
        <Row>
          <Col className="col-md-3">
            <CardWrapper className="p-0">
              <div className="full-box-0">
                <ul className="profile-list">
                  {auth?.user?.roleId === 2 && <>
                    <li className={activeTab === 0 ? 'profile-list-item active' : 'profile-list-item'} onClick={() => setActiveTab(0)}>Company Details</li>
                    <li className={activeTab === 1 ? 'profile-list-item active' : 'profile-list-item'} onClick={() => setActiveTab(1)}>Business Hours</li>
                  </>}
                  {auth?.user?.roleId === 3 && <>
                      <li className={activeTab === 5 ? 'profile-list-item active' : 'profile-list-item'} onClick={() => setActiveTab(5)}>Personal Details</li>
                  </>}
                  <li className={activeTab === 2 ? 'profile-list-item active' : 'profile-list-item'} onClick={() => setActiveTab(2)}>Change Password</li>
                  {auth?.user?.roleId === 3 && <>
                      <li className={activeTab === 6 ? 'profile-list-item active' : 'profile-list-item'} onClick={() => setActiveTab(6)}>Expertise</li>
                  </>}
                  {auth?.user?.roleId === 2 && <>
                    <li className={activeTab === 3 ? 'profile-list-item active' : 'profile-list-item'} onClick={() => setActiveTab(3)}>Subscription</li>
                    <li className={activeTab === 4 ? 'profile-list-item active' : 'profile-list-item'} onClick={() => setActiveTab(4)}>Storage & Location</li>
                  </>}
                </ul>
              </div>
            </CardWrapper>
          </Col>
          <Col className="col-md-9">
          <CardWrapper className="full-box-0 p-0">
            <RenderAdminProfile 
              activeTab={activeTab} 
              userDetail={auth} 
              setAuth={setAuth} 
            />
          </CardWrapper>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default ProfileOverview;
